/// <reference types="vite/client" />
// Thin wrapper around the dashboard's only direct-Function calls: /jobsEnqueue
// (for re-runs) and /signedUpload (for future dashboard-driven recording).
// Mirrors @cairntools/cli/src/lib/jobs-api-client.js but uses the current
// signed-in user's Firebase ID token from the firebase web SDK.

import { auth } from './firebase.js'

const FUNCTIONS_BASE =
  import.meta.env.VITE_FUNCTIONS_URL ?? 'https://us-central1-cairn-ebf35.cloudfunctions.net'

async function authHeaders() {
  const user = auth.currentUser
  if (!user) throw new Error('Not signed in')
  const token = await user.getIdToken()
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  }
}

/**
 * @param {import('zod').TypeOf<typeof import('@cairntools/schema').JobEnvelopeSchema>} envelope
 */
export async function enqueueJob(envelope) {
  const headers = await authHeaders()
  const res = await fetch(`${FUNCTIONS_BASE}/jobsEnqueue`, {
    method: 'POST',
    headers,
    body: JSON.stringify(envelope),
  })
  if (!res.ok) {
    const body = await res.text().catch(() => '<no body>')
    throw new Error(`enqueueJob ${res.status}: ${body.slice(0, 400)}`)
  }
  return res.json()
}
